<script>
import TourMagList from '@/modules/Tour/Admin/List';
import TourListComponent from '@/modules/Tour/Admin/List/component.vue';


export default {
  components: {
    TourListComponent,
  },
  data: () => ({
    title: 'Туры',
    module: new TourMagList(),
  }),
  mounted() {
    this.module.init();
  },
};
</script>
<template>
  <TemplateItem
    :title="title"
    :loading="module.loading"
    full>
    <div class="app-template-header">
      <div class="app-template-header__title">Мои туры</div>
      <a href="#/admin/tour/add" class="" style="margin-top: 6px"><button type="button" class="btn btn-primary">Добавить</button></a>
    </div>
    <TourListComponent
      :module="module"
    />
  </TemplateItem>
</template>

<style lang="scss">
.app-template-header {
  height: 50px;
  border-bottom: 2px solid #e4e7ed;
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  background: #fff;
  &__title {
    line-height: 48px;
    padding: 0 16px;
    font-size: 18px;
  }
}


.app-template-page {
  &__body {
    .tour-list-form {
      background: #e4e7ed;

      .f-item__label {
        padding-left: 2px;
        font-size: 14px;
        min-height: 18px;
      }
    }

    .wrap{
      min-width: 1060px;
      max-width: 1060px;
      width: 1060px;
      margin: 0 auto;
      padding: 8px;
    }
  }
}
</style>
